import { transparentize } from 'polished'
import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocused: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isReadOnly: boolean

	hasSuffix?: boolean
}

export const DefaultInput = styled.input<Props>`
	background-color: ${({ isHovered, isFocusVisible, isDisabled, isFocused, isReadOnly, hasError, theme }) => {
		if (isDisabled) return theme.color.input.backgroundDisabled
		if (isReadOnly) return theme.color.input.backgroundReadOnly
		if (isHovered || isFocusVisible || isFocused)
			return hasError ? theme.color.input.backgroundErrorHover : theme.color.input.backgroundHover
		return hasError ? theme.color.input.backgroundError : theme.color.input.background
	}};
	border: 1px ${({ isReadOnly }) => (isReadOnly ? 'dashed' : 'solid')} ${({
		isHovered,
		isFocusVisible,
		isDisabled,
		isReadOnly,
		isFocused,
		hasError,
		theme,
	}) => {
		if ((isFocused || isFocusVisible) && !isDisabled && !isReadOnly) return theme.color.input.borderHover
		if (isHovered && !isDisabled && !isReadOnly) return hasError ? theme.color.danger : theme.color.input.borderHover
		return hasError ? theme.color.danger : theme.color.input.border
	}};
	border-radius: 4px;
	color: ${({ theme, isDisabled, isReadOnly }) => {
		if (isDisabled) return theme.color.textMuted
		if (isReadOnly) return theme.color.text
		return theme.color.text
	}};
	display: block;
	font-size: ${helpers.font.size.base};
	line-height: 1.2;
	margin: 0;
	outline: 0;
	/* This is a very simple solution to get the suffix in for this application since if present, it will always be "DKK" */
	padding: ${({ hasSuffix }) => (hasSuffix ? '8px 46px 8px 12px' : '8px 12px')};
	position: relative;
	text-align: left;
	transition: border 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, background-color 0.2s ease;
	-webkit-tap-highlight-color: transparent;
	width: 100%;
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};

	&::placeholder {
		color: ${({ hasError, theme }) => (hasError ? transparentize(0.65, theme.color.textMuted) : theme.color.textMuted)};
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button,
	&::-webkit-calendar-picker-indicator {
		display: none;
		appearance: none;
	}

	/* Hides number arrows in Firefox */
	&[type=number] {
		-moz-appearance: textfield; /* stylelint-disable-line */
	}

	/* Controls the height for date fields, especially relevant for Safari */
	&[type=date] {
		height: 40px;
	}

	/* Proper internal styling for Safari date field */
	&::-webkit-datetime-edit {
		margin-top: -2px;
	}

	/* Proper internal styling for Safari date field on mobile */
	&::-webkit-date-and-time-value {
		text-align: left;
		min-height: 24px;
	}
`
